export enum KnownError {
  NotFound = 'not-found',
  Timeout = 'timeout',
  InternalServerError = 'internal-server-error',
  UserAlreadyExists = 'user-already-exists',
  UserNotVerified = 'user-not-verified',
  InvalidCredentials = 'invalid-credentials',
  CommonPassword = 'common-password',
  INVALID_MAIL = 'INVALID_MAIL',
  INVALID_REQUEST = 'INVALID_REQUEST',
  // RFC 6749 §5.2 token-endpoint error codes.
  INVALID_GRANT = 'invalid_grant',
  INVALID_CLIENT = 'invalid_client',
  INVALID_SCOPE = 'invalid_scope',
  UNSUPPORTED_GRANT_TYPE = 'unsupported_grant_type',
  UNAUTHORIZED_CLIENT = 'unauthorized_client',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  INVALID_TOKEN = 'INVALID_TOKEN',
  MISSING_TOKEN = 'MISSING_TOKEN',
  VERIFICATION_INVALID = 'VERIFICATION_INVALID',
  NOT_ALLOWED = 'NOT_ALLOWED',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  INVALID_FIELD_VALUE = 'INVALID_FIELD_VALUE',
  INVALID_FILE_TYPE = 'INVALID_FILE_TYPE',
  FORBIDDEN = 'FORBIDDEN',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  WorkspaceAlreadyExists = 'workspaceAlreadyExists',
  NoPermissions = 'noPermissions',
  RemoveMembersFirst = 'removeMembersFirst',
  UserAlreadyInBuiltInGroup = 'userAlreadyInBuiltInGroup',
  NoRemoveAdmin = 'noRemoveAdmin',
  InvalidSettingName = 'InvalidSettingName',
  TwoFactorRequired = 'twoFactorRequired',
  TwoFactorAlreadyEnabled = 'twoFactorAlreadyEnabled',
  InvalidTwoFactorCode = 'InvalidTwoFactorCode',
  PropertyTypeMismatch = 'propertyTypeMismatch',
  PropertyIsMissingForeignPropertyId = 'propertyIsMissingForeignPropertyId',
  RequestingEntityInvalid = 'requestingEntityInvalid',
  INVALID_CAPTCHA = 'INVALID_CAPTCHA',
  AutomationVersionStatusInvalid = 'automationVersionStatusInvalid',
  AutomationError = 'automationError',
  TestException = 'testException',
  LabelInUse = 'labelInUse',
  StatusInUse = 'statusInUse',
  MultipleFilesInUse = 'multipleFilesInUse',
  MultipleLabelsInUse = 'multipleLabelsInUse',
  ChartTooManyItems = 'chartTooManyItems',
  ChartTooManyUniqueCategories = 'chartTooManyUniqueCategories',
  ChartTooManyUniqueStackKeys = 'chartTooManyUniqueStackKeys',
  ChartTooManyDateRangeLabels = 'chartTooManyDateRangeLabels',
  ChartTooManyDataPoints = 'chartTooManyDataPoints',
  ChartTooManyDatasets = 'chartTooManyDatasets',
  ChartAggregationTimeout = 'chartAggregationTimeout',
  ChartInvalidValueFieldAggregation = 'chartInvalidValueFieldAggregation',
  ChartInvalidValueFieldColor = 'chartInvalidValueFieldColor',
  ChartInvalidValueFieldPosition = 'chartInvalidValueFieldPosition',
  ViewAsSessionInvalid = 'viewAsSessionInvalid',
  ViewAsReadOnly = 'viewAsReadOnly',
  ViewAsSurfaceUnavailable = 'viewAsSurfaceUnavailable',
  POLICY_LIMIT_EXCEEDED = 'policy-limit-exceeded',
  PLAN_FEATURE_NOT_ENTITLED = 'plan-feature-not-entitled',
  WORKSPACE_SUSPENDED = 'workspace-suspended',
  WORKSPACE_SUBSCRIPTION_REQUIRED = 'workspace-subscription-required',
  USAGE_LIMIT_EXCEEDED = 'usage-limit-exceeded',
  ON_DEMAND_USAGE_BLOCKED = 'on-demand-usage-blocked',
  PAYMENT_DECLINED = 'payment-declined',
  SUBSCRIPTION_PAYMENT_PAST_DUE = 'subscription-payment-past-due',
  SUBSCRIPTION_RENEWAL_IN_PROGRESS = 'subscription-renewal-in-progress',
  CHECKOUT_IN_PROGRESS = 'checkout-in-progress',
  CHECKOUT_RECOVERY_PENDING = 'checkout-recovery-pending',
  CHECKOUT_AMOUNT_CHANGED = 'checkout-amount-changed',
  SEAT_QUANTITY_BELOW_MEMBERS = 'seat-quantity-below-members',
  SEAT_QUANTITY_BELOW_MINIMUM = 'seat-quantity-below-minimum',
  CART_HOLDS_PREPARED_OFFER = 'cart-holds-prepared-offer',
  SUBSCRIPTION_PAID_MANUALLY = 'subscription-paid-manually',
  SUBSCRIPTION_ON_CUSTOM_PLAN = 'subscription-on-custom-plan',
  PAYMENT_METHOD_REQUIRED = 'payment-method-required',
  CollectionItemAlreadyExists = 'collectionItemAlreadyExists',
  RECORD_ALREADY_EXISTS = 'record-already-exists',
  ButtonExecutionLimitReached = 'buttonExecutionLimitReached',
  ButtonConditionsNotMet = 'buttonConditionsNotMet',
  Conflict = 'conflict',
  // T-336 Gantt date writes (`reschedule`, `reschedule/undo`)
  RescheduleDisabled = 'rescheduleDisabled',
  RescheduleStale = 'rescheduleStale',
  RescheduleInProgress = 'rescheduleInProgress',
  RescheduleConfirmationRequired = 'rescheduleConfirmationRequired',
  RescheduleCascadeTooLarge = 'rescheduleCascadeTooLarge',
  TimeTrackerInUse = 'timeTrackerInUse',
  AgentCronIntervalTooShort = 'agentCronIntervalTooShort',
  AutomationAppStateChangeNotAllowed = 'automationAppStateChangeNotAllowed',
  AutomationAppRedirectUriRequired = 'automationAppRedirectUriRequired',
  AutomationAppOAuthClientManagedByProvider = 'automationAppOAuthClientManagedByProvider',
}
